module.exports = __webpack_public_path__ + "img/MGH-Toyosu-8.fd5a7528.jpg";